import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'
import type { IAddBankAccountRequest } from '~/@api/generated-api-types-account/Api'
import type { AddBankAccountFormData } from './AddBankAccountForm'

type AddBankAccountPayload = AddBankAccountFormData & {
  twoFACode: string
}

const defaultPayload = {
  twoFACode: '',
  iban: '',
  isOwner: false,
} satisfies AddBankAccountPayload

function useAddBankAccount() {
  const [addStep, setAddStep] = useState<'add' | 'verify' | 'success'>('add')
  const [addBankAccountPayload, setAddBankAccountPayload] =
    useState<AddBankAccountPayload>(defaultPayload)
  const client = useApiClientAccount()

  async function addBankAccount(props: IAddBankAccountRequest) {
    return client.account
      .bankAccountControllerAdd(props, { secure: true })
      .then((res) => res.data)
  }

  const {
    mutate: addBankAccountMutation,
    isPending: isAddingBankAccount,
    error,
  } = useMutation({
    mutationFn: addBankAccount,
  })

  return {
    addStep,
    setAddStep,
    addBankAccountPayload,
    setAddBankAccountPayload,
    addBankAccount: addBankAccountMutation,
    isAddingBankAccount,
    error: getApiErrorMessage(error, 'Bankový účet sa nepodarilo pridať.'),
  }
}

export { useAddBankAccount }
